<template>
  <div class="fadeInRight polling-failure-log">
    <div class="title-box clearfix">
      <span class="m-title">卡片轮询失败日志</span>
    </div>

    <div class="content-box">
      <!-- 统计信息卡片 -->
      <div class="stats-cards" v-if="stats">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-card shadow="hover" class="stat-card">
              <div class="stat-content">
                <div class="stat-icon" style="background: #409eff;">
                  <i class="el-icon-warning"></i>
                </div>
                <div class="stat-info">
                  <div class="stat-value">{{ stats.totalFailureCount || 0 }}</div>
                  <div class="stat-label">总失败次数</div>
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="6">
            <el-card shadow="hover" class="stat-card">
              <div class="stat-content">
                <div class="stat-icon" style="background: #f56c6c;">
                  <i class="el-icon-error"></i>
                </div>
                <div class="stat-info">
                  <div class="stat-value">{{ stats.noloopCardCount || 0 }}</div>
                  <div class="stat-label">不轮询卡数</div>
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="6">
            <el-card shadow="hover" class="stat-card">
              <div class="stat-content">
                <div class="stat-icon" style="background: #e6a23c;">
                  <i class="el-icon-document"></i>
                </div>
                <div class="stat-info">
                  <div class="stat-value">{{ stats.affectedCardCount || 0 }}</div>
                  <div class="stat-label">影响卡片数</div>
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="6">
            <el-card shadow="hover" class="stat-card">
              <div class="stat-content">
                <div class="stat-icon" style="background: #67c23a;">
                  <i class="el-icon-refresh"></i>
                </div>
                <div class="stat-info">
                  <div class="stat-value">{{ stats.lastSyncTime || '-' }}</div>
                  <div class="stat-label">最后同步</div>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>

      <!-- 查询表单 -->
      <el-card style="margin-top: 20px;">
        <el-form :inline="true" :model="query" class="query-form">
          <el-form-item label="查询日期">
            <el-date-picker
              v-model="dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              style="width: 240px;">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="卡号ICCID">
            <el-input
              v-model="query.iccidMark"
              placeholder="请输入卡号"
              clearable
              style="width: 200px;">
            </el-input>
          </el-form-item>
          <el-form-item label="不轮询状态">
            <el-select
              v-model="query.isAddedToNoloop"
              placeholder="请选择"
              clearable
              style="width: 120px;">
              <el-option label="全部" value=""></el-option>
              <el-option label="是" :value="true"></el-option>
              <el-option label="否" :value="false"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchLogs" icon="el-icon-search">查询</el-button>
            <el-button @click="resetQuery" icon="el-icon-refresh-left">重置</el-button>
            <el-button type="success" @click="exportLogs" icon="el-icon-download">导出Excel</el-button>
            <el-button type="warning" @click="manualSyncData" icon="el-icon-refresh">手动同步</el-button>
          </el-form-item>
        </el-form>
      </el-card>

      <!-- 数据表格 -->
      <el-card style="margin-top: 20px;">
        <el-table
          :data="tableData"
          border
          stripe
          v-loading="loading"
          style="width: 100%">
          <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
          <el-table-column prop="iccidMark" label="卡号ICCID" width="180" show-overflow-tooltip></el-table-column>
          <el-table-column prop="accountName" label="账户名称" width="150" show-overflow-tooltip></el-table-column>
          <el-table-column prop="failureReason" label="失败原因" min-width="200" show-overflow-tooltip></el-table-column>
          <el-table-column prop="errorCode" label="错误码" width="120"></el-table-column>
          <el-table-column prop="failureCount" label="失败次数" width="100" align="center">
            <template slot-scope="scope">
              <el-tag :type="scope.row.failureCount >= 4 ? 'danger' : 'warning'">
                {{ scope.row.failureCount }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="isAddedToNoloop" label="不轮询" width="100" align="center">
            <template slot-scope="scope">
              <el-tag :type="scope.row.isAddedToNoloop ? 'danger' : 'success'">
                {{ scope.row.isAddedToNoloop ? '是' : '否' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="首次失败时间" width="160">
            <template slot-scope="scope">
              {{ formatDateTime(scope.row.createTime) }}
            </template>
          </el-table-column>
          <el-table-column prop="failureDate" label="失败日期" width="120">
            <template slot-scope="scope">
              {{ formatOnlyDate(scope.row.failureDate) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="viewDetail(scope.row)">详情</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <el-pagination
          @size-change="handlePageSizeChange"
          @current-change="handlePageChange"
          :current-page="pagination.pageNo"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
          style="margin-top: 20px; text-align: right;">
        </el-pagination>
      </el-card>
    </div>

    <!-- 详情对话框 -->
    <el-dialog
      title="轮询失败详情"
      :visible.sync="detailDialogVisible"
      width="600px">
      <el-descriptions :column="2" border v-if="currentDetail">
        <el-descriptions-item label="卡号ICCID">{{ currentDetail.iccidMark }}</el-descriptions-item>
        <el-descriptions-item label="账户名称">{{ currentDetail.accountName }}</el-descriptions-item>
        <el-descriptions-item label="失败日期">{{ formatOnlyDate(currentDetail.failureDate) }}</el-descriptions-item>
        <el-descriptions-item label="失败次数">{{ currentDetail.failureCount }}</el-descriptions-item>
        <el-descriptions-item label="错误码">{{ currentDetail.errorCode }}</el-descriptions-item>
        <el-descriptions-item label="不轮询状态">
          <el-tag :type="currentDetail.isAddedToNoloop ? 'danger' : 'success'">
            {{ currentDetail.isAddedToNoloop ? '是' : '否' }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="失败原因" :span="2">{{ currentDetail.failureReason }}</el-descriptions-item>
        <el-descriptions-item label="首次失败时间" :span="2">{{ formatDateTime(currentDetail.createTime) }}</el-descriptions-item>
        <el-descriptions-item label="最后更新时间" :span="2">{{ formatDateTime(currentDetail.updateTime) }}</el-descriptions-item>
      </el-descriptions>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import onresize from "@/mixins/resize.js";
import { getFailureLogList, getFailureStats, manualSync, exportFailureLog, queryByIccid } from "@/api/polling/pollingFailureLog.js";

export default {
  name: "pollingFailureLog",
  mixins: [onresize],
  data() {
    return {
      stats: null,
      query: {
        iccidMark: '',
        isAddedToNoloop: ''
      },
      dateRange: [],
      tableData: [],
      loading: false,
      pagination: {
        pageNo: 1,
        pageSize: 20,
        total: 0
      },
      detailDialogVisible: false,
      currentDetail: null
    };
  },
  created() {
    this.initDateRange();
    this.loadStats();
    this.loadLogs();
  },
  methods: {
    initDateRange() {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);

      this.dateRange = [
        this.formatDate(start),
        this.formatDate(end)
      ];
    },

    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    loadStats() {
      const params = {};
      if (this.dateRange && this.dateRange.length === 2) {
        params.startDate = this.dateRange[0];
        params.endDate = this.dateRange[1];
      }

      getFailureStats(params).then((res) => {
        // request拦截器已经处理了响应，res就是stats对象
        if (res) {
          this.stats = res;
        }
      }).catch((error) => {
        console.error('获取统计信息失败:', error);
      });
    },

    loadLogs() {
      this.loading = true;

      const params = {
        pageNo: this.pagination.pageNo,
        pageSize: this.pagination.pageSize
      };

      if (this.dateRange && this.dateRange.length === 2) {
        params.startDate = this.dateRange[0];
        params.endDate = this.dateRange[1];
      }

      if (this.query.iccidMark) {
        params.iccidMark = this.query.iccidMark;
      }

      if (this.query.isAddedToNoloop !== '') {
        params.isAddedToNoloop = this.query.isAddedToNoloop;
      }

      getFailureLogList(params).then((res) => {
        this.loading = false;
        // request拦截器已经处理了响应，直接返回了data部分（即page对象）
        // res就是page对象，包含rows和total
        if (res) {
          this.tableData = res.rows || [];
          this.pagination.total = res.total || 0;
        } else {
          this.$message({
            showClose: true,
            message: '查询失败',
            type: "error",
          });
        }
      }).catch((error) => {
        this.loading = false;
        console.error('查询失败:', error);
        this.$message({
          showClose: true,
          message: '查询失败',
          type: "error",
        });
      });
    },

    searchLogs() {
      this.pagination.pageNo = 1;
      this.loadLogs();
      this.loadStats();
    },

    resetQuery() {
      this.query = {
        iccidMark: '',
        isAddedToNoloop: ''
      };
      this.initDateRange();
      this.searchLogs();
    },

    exportLogs() {
      const params = {};

      if (this.dateRange && this.dateRange.length === 2) {
        params.startDate = this.dateRange[0];
        params.endDate = this.dateRange[1];
      }

      if (this.query.iccidMark) {
        params.iccidMark = this.query.iccidMark;
      }

      if (this.query.isAddedToNoloop !== '') {
        params.isAddedToNoloop = this.query.isAddedToNoloop;
      }

      this.$message({
        message: '正在导出，请稍候...',
        type: 'info'
      });

      exportFailureLog(params).then((blob) => {
        // 创建下载链接
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement('a');
        link.href = url;

        // 生成文件名
        const fileName = `轮询失败日志_${params.startDate || ''}_${params.endDate || ''}_${new Date().getTime()}.xlsx`;
        link.setAttribute('download', fileName);

        // 触发下载
        document.body.appendChild(link);
        link.click();

        // 清理
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        this.$message({
          message: '导出成功！',
          type: 'success'
        });
      }).catch((error) => {
        console.error('导出失败:', error);
        this.$message({
          message: '导出失败',
          type: 'error'
        });
      });
    },

    manualSyncData() {
      const today = this.formatDate(new Date());

      this.$confirm('确定要手动同步今天的数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        manualSync(today).then((res) => {
          // request拦截器处理后，res就是返回的数据
          this.$message({
            message: '同步成功！',
            type: 'success'
          });
          this.loadLogs();
          this.loadStats();
        }).catch((error) => {
          console.error('同步失败:', error);
          this.$message({
            showClose: true,
            message: '同步失败',
            type: 'error'
          });
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消同步'
        });
      });
    },

    viewDetail(row) {
      this.currentDetail = row;
      this.detailDialogVisible = true;
    },

    handlePageSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.pageNo = 1;
      this.loadLogs();
    },

    handlePageChange(val) {
      this.pagination.pageNo = val;
      this.loadLogs();
    },

    // 格式化日期时间 yyyy-MM-dd HH:mm:ss
    formatDateTime(datetime) {
      if (!datetime) return '-';
      const date = new Date(datetime);
      if (isNaN(date.getTime())) return datetime;

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },

    // 格式化日期 yyyy-MM-dd
    formatOnlyDate(dateStr) {
      if (!dateStr) return '-';
      // 如果已经是 yyyy-MM-dd 格式，直接返回
      if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
        return dateStr;
      }
      // 否则解析并格式化
      const date = new Date(dateStr);
      if (isNaN(date.getTime())) return dateStr;

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');

      return `${year}-${month}-${day}`;
    }
  }
};
</script>

<style scoped>
.polling-failure-log {
  padding: 20px;
}

.stats-cards {
  margin-bottom: 20px;
}

.stat-card {
  transition: all 0.3s;
}

.stat-card:hover {
  transform: translateY(-5px);
}

.stat-content {
  display: flex;
  align-items: center;
  padding: 10px;
}

.stat-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
}

.stat-icon i {
  font-size: 28px;
  color: white;
}

.stat-info {
  flex: 1;
}

.stat-value {
  font-size: 28px;
  font-weight: bold;
  color: #303133;
  line-height: 1.2;
}

.stat-label {
  font-size: 14px;
  color: #909399;
  margin-top: 5px;
}

.query-form {
  margin-bottom: 0;
}

.query-form .el-form-item {
  margin-bottom: 0;
}
</style>

